// extracted by mini-css-extract-plugin
module.exports = {"info":"info___Q0VTp"};